
import { delay } from 'redux-saga';
import { push } from 'react-router-redux';
import { all, fork, put, select, takeEvery } from "redux-saga/effects";
import { Constants, Utils } from '../../helpers';
import { SignalRTypes, SportEventsActionTypes } from '../actions';


export function* requests() {

	yield takeEvery(SignalRTypes.SportEvents_Response, function* ({ response }) {
		try {
			window.console.response("Events", response)
			const { app } = yield select();

			switch (response.status) {
				case 1:
					let betTypes = Utils.handleBetTypes(response.data.topBetTypes);

					let selectedValues = []

					if (betTypes && betTypes.optionsBetTypes && betTypes.optionsBetTypes.length > 0) {
						for (let i = 0; i < Constants.ColumnsNumber; i++) {
							selectedValues[i] = betTypes.optionsBetTypes[i] && betTypes.optionsBetTypes[i].key
						}
					}
					yield put({
						type: SportEventsActionTypes.SportEvents_Success,
						betTypes: betTypes,
						sportEvents: response.data.sportEvents,
						eventOdds: response.data.eventOdds,
						eventsIds: response.data.sportEventIds,
						upcomingEvents: response.data.upcomingEvents,
						upcomingEventIds: response.data.upcomingEventIds,
						selectedValues: selectedValues,
					})

					yield delay(50);

					yield put({
						type: SportEventsActionTypes.SportEvents_OddFields_Success,
						eventOddFields: response.data.eventOddFields,
					})

					break;

				case 3:

					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;


			}

			let item = null;
			let eventId = app.match.params["eventId"];
			let newEventId = `${app.feedId}_${app.match.params.sport}_${eventId}`

			//Refresh page
			if (eventId) {
				item = response.data.sportEvents[newEventId]
			}

			//If no item, dont try load all bet types
			if (!item)
				return;

			//else Set the event item and get all Bettypes of sport event
			//yield put({ type: SportEventsActionTypes.Set_Event, item: item });
			//yield put({ type: SignalRTypes.AllBetTypes_Request })


		} catch (e) {
			window.log("ERROR", e)
		}
	})

	yield takeEvery(SignalRTypes.KironSportEvents_Response, function* ({ response }) {
		try {
			window.console.response("Kiron Events", response)
			const { app, sportEvents } = yield select();

			switch (response.status) {
				case 1:

					let data =  []; 
					 Object.values(response.data).map((item) => 
					data.push(

						{   ...item ,
							eventDate: item.eventDateOfMatchFormated, 
							eventNumber:  item.kironEventNumber
						})
						
					
						
					)
					yield put({
						type: SportEventsActionTypes.SportEvents_Events_FeedChange,
						sportEvents: response.data,
						
					})

					let event = Object.values(response.data)[0];
                    yield put(push(`/casino/${event.feed.feedId}/${event.sport.sportId}/${event.kironEventNumber}/${event.eventId}`));

					break;



				case 3:

					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;
					default: 

			}

		} catch (e) {
			window.log("ERROR", e)
		}
	})

	yield takeEvery(SignalRTypes.AllBetTypes_Response, function* ({ response }) {
		try {
			let events = {};
			yield put({ type: SportEventsActionTypes.Set_Event, item: response.data.sportEvent , drawEvents: response.data && response.data.drawEvents });
			if (response.data.sportEvent) {
				events[response.data.sportEvent.key] = response.data.sportEvent
			}
			window.console.response("All BetTypes", response)

			let drillDownTabs = [];
			response.data.eventOddGroups && Object.values(response.data.eventOddGroups).map(item => drillDownTabs.pushUnique(item.betTypeDrillDownGroupName))
			switch (response.status) {
				case 1:
					let specialGroupOdds = {};
					let newFilteredGroupIds= [];
					let specialOddFields = [];
					let specialOddFieldGroup={}
					const eventSpecialTemplateOddGroupIds= response.data.eventSpecialTemplateOddGroupIds;
					eventSpecialTemplateOddGroupIds && response.data.eventOdds &&  eventSpecialTemplateOddGroupIds.map(group=>{
						group.goalScorer.map((groupKey) =>{
							Object.entries(response.data.eventOdds).map(([key , odds]) => {
								Object.keys(odds).map((key) => {
									if (
									  `${odds[key].betType.betTypeGroupId}_${odds[key].betType.betTypeGroupName}` ===
									  groupKey
									) {
										specialGroupOdds[key] = odds[key];
									}
								  });
							});
						})
					})
					const eventOddGroupIds = response.data.eventOddGroupIds;
					if(eventSpecialTemplateOddGroupIds && Object.values(eventSpecialTemplateOddGroupIds) && Object.values(eventSpecialTemplateOddGroupIds).length > 0 ){
						(eventOddGroupIds.map(groupId=>{
							Object.values(eventSpecialTemplateOddGroupIds).map((specialGroupId)=>{
								Object.values(specialGroupId).map(values=>{
									if(!(values.includes(groupId) && (values.indexOf(groupId) !== values.length -1))){
										newFilteredGroupIds.push(groupId)
									}
								})
							})
							
						}))
					}else{
						newFilteredGroupIds=eventOddGroupIds
					} 
					eventSpecialTemplateOddGroupIds && eventSpecialTemplateOddGroupIds.map(specialIdGroup=>{
						Object.values(specialIdGroup).map(group=>{
							group.map((groupId , idx)=>{
								response.data.eventOddFields && Object.values(response.data.eventOddFields).map(item=>{
												Object.values(item).map(oddField=>{
													if((`${oddField.betType.betTypeGroupId}_${oddField.betType.betTypeGroupName}` == groupId) && oddField.betType.specialTemplateName && oddField.oddFieldColumn == idx+1){
														specialOddFields.push(oddField)
													}
									})
								})
							})
						})
					})
					specialOddFields && specialOddFields.length > 0 && specialOddFields.map((oddField)=>{
						if(specialOddFieldGroup[`row-${oddField.oddFieldRow}-${oddField.oddField}`]){
							specialOddFieldGroup[`row-${oddField.oddFieldRow}-${oddField.oddField}`].push(oddField)
						}else{
							specialOddFieldGroup[`row-${oddField.oddFieldRow}-${oddField.oddField}`]=[oddField]
						}
					})
					yield put({
						type: SportEventsActionTypes.SportEvents_Success,
						betTypes: {},
						sportEvents: events,
						eventOddGroups: response.data.eventOddGroups,
						eventOddGroupIds: newFilteredGroupIds,
						eventOdds: response.data.eventOdds,
						specialGroupOdds:specialGroupOdds,
						specialOddFieldGroup:specialOddFieldGroup,
						eventsIds: response.data.sportEvent ? [response.data.sportEvent.key] : [],
						selectedValues: [],
						upcomingEvents: {},
						upcomingEventIds: [],
						drillDownTabs: drillDownTabs
					})

					yield delay(50);

					yield put({
						type: SportEventsActionTypes.SportEvents_OddFields_Success,
						eventOddFields: response.data.eventOddFields,
					})
					yield put({
						type: SignalRTypes.Get_Draw_Odds_Response,
					})

					break;

				case 3:
					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;

			}
		} catch (e) {
			window.log("ERROR", e)
		}
	})
	yield takeEvery(SignalRTypes.KironEvent_Response, function* ({ response }) {
		try {
			let oddFields = {};
			yield put({ type: SportEventsActionTypes.Set_Event, item: response.data.sportEvent });
			window.console.response("Kiron All BetTypes", response)
			switch (response.status) {
				case 1:

					yield put({
						type: SportEventsActionTypes.SportEvents_Odds_Success,
						eventOdds: response.data.eventOdds,
					})

					yield delay(50);

					yield put({
						type: SportEventsActionTypes.SportEvents_OddFields_Success,
						eventOddFields: response.data.eventOddFields,
					})

					break;

				case 3:
					yield put({
						type: SportEventsActionTypes.SportEvents_Error,
						error: response.message,
					})
					break;
					default:

			}
		} catch (e) {
			window.log("ERROR", e)
		}
	})
}

export default function* sportSaga() {
	yield all([
		fork(requests),
	])
}
